import { Account, AccountStatus } from "@ctypes";
import { useUser } from "@hooks/user";

export const useAccount = () => {
  const { beneficiaries, ...rest } = useUser();

  const accounts: Array<Account> = [];

  beneficiaries?.forEach((beneficiary) => {
    beneficiary?.goals?.forEach((goal) => {
      if (goal?.accounts) {
        goal.accounts.forEach((account) => {
          if (account) {
            accounts.push(account);
          }
        });
      }
    });
  });

  const isAccountInReview = accounts.some((account) => account.status === AccountStatus.InReview);
  const isAccountActive = accounts.every((account) => account.status === AccountStatus.Active);

  return { data: accounts, isAccountActive, isAccountInReview, ...rest };
};
